<template>
  <div class="activityGoods">
    <div class="title">活动商品</div>
    <div class="main mr40">
      <el-form :model="form"
               :inline="true"
               class="demo-form-inline">
        <el-form-item label="商品ID：">
          <el-input v-model="form.spuId"
                    clearable
                    placeholder="请输入商品ID"></el-input>
        </el-form-item>
        <el-form-item label="商品名称：">
          <el-input v-model="form.productName"
                    clearable
                    placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <!--   <el-form-item label="商品分类：">
                    <el-cascader placeholder="请选择分类" clearable :props="{ value: 'id', label: 'name', multiple: true, expandTrigger: 'hover' }" :options="options" collapse-tags></el-cascader>
                </el-form-item> -->
        <el-form-item label="库存：">
          <div style="display: flex">
            <el-input v-model="form.merchandise_inventory[0]"
                      clearable
                      style="width: 160px"
                      oninput="value=value.replace(/[^\d]/g,'')"></el-input> <span style="margin: 0 8px">-</span>
            <el-input v-model="form.merchandise_inventory[1]"
                      clearable
                      style="width: 160px"
                      oninput="value=value.replace(/[^\d]/g,'')"></el-input>
          </div>
        </el-form-item>

        <el-form-item label="销售价：">
          <div style="display: flex">
            <el-input v-model="form.prices_mains[0]"
                      clearable
                      style="width: 160px"
                      oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
              <template slot="append">元</template>
            </el-input>
            <span style="margin: 0 8px">-</span>
            <el-input v-model="form.prices_mains[1]"
                      clearable
                      style="width: 160px"
                      oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
              <template slot="append">元</template>
            </el-input>
          </div>
        </el-form-item>
        <el-form-item class="mr20">
          <el-button @click="init">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     @click="getGoodsList">搜索</el-button>
        </el-form-item>
      </el-form>
      <div class="tabs">
        <el-tabs v-model="activeName"
                 @tab-click="handleClick">
          <el-tab-pane label="拼团"
                       name="activity_team"></el-tab-pane>
          <el-tab-pane label="订单返现"
                       name="activity_share"></el-tab-pane>
          <el-tab-pane label="接龙购"
                       name="activity_link"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="table">
        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  tooltip-effect="dark"
                  style="width: 100%"
                  :row-key="getRowKeys"
                  @selection-change="handleSelectionChange"
                  v-loading="tableLoad">
          <el-table-column type="selection"
                           width="55"
                           align="center"
                           :selectable="checkSelectable"
                           :reserve-selection="true"> </el-table-column>
          <el-table-column prop="product_sku_id"
                           align="center"
                           label="商品ID"
                           width="160"> </el-table-column>
          <el-table-column prop="img_url"
                           align="center"
                           label="商品图片"
                           width="160">
            <template slot-scope="scope">
              <el-avatar shape="square"
                         :size="60"
                         fit="cover"
                         :src="scope.row.img_url"></el-avatar>
            </template>
          </el-table-column>
          <el-table-column prop="goods_name"
                           align="center"
                           label="商品名称"
                           show-overflow-tooltip
                           width="160"> </el-table-column>
          <el-table-column prop="standard_id"
                           align="center"
                           label="分类"
                           show-overflow-tooltip
                           width="160">
            <template slot-scope="scope">
              <span v-for="(item,index) in scope.row.standard_name"
                    :key="index">
                {{item}}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="sold_stock"
                           align="center"
                           sortable
                           label="销量"
                           width="160"> </el-table-column>
          <el-table-column prop="merchandise_inventory"
                           align="center"
                           sortable
                           label="库存"
                           width="160"> </el-table-column>
          <el-table-column prop="max_sales_num"
                           align="center"
                           label="参与活动商品数量"
                           width="140"> </el-table-column>
          <el-table-column align="center"
                           label="剩余活动商品数量"
                           width="140">
            <template slot-scope="scope">
              {{
              Number(scope.row.max_sales_num)-Number(scope.row.sold_stock)
              }}
            </template>
          </el-table-column>
          <el-table-column prop="price_sell"
                           align="center"
                           sortable
                           label="销售价(元)"
                           width="160"> </el-table-column>
          <el-table-column prop="price_market"
                           align="center"
                           sortable
                           label="市场价(元)"
                           width="160"> </el-table-column>
          <el-table-column v-if="activeName == 'activity_team'"
                           prop="price"
                           align="center"
                           label="拼团价(元)"
                           width="160"> </el-table-column>
          <el-table-column v-if="activeName == 'activity_link'"
                           prop="price"
                           align="center"
                           label="活动价(元)"
                           width="160"> </el-table-column>
          <el-table-column v-if="activeName == 'activity_team'"
                           prop="leader_price"
                           align="center"
                           label="团长价(元)"
                           width="160"> </el-table-column>
          <el-table-column v-if="activeName == 'activity_share' || activeName == 'activity_link'"
                           prop="reward_cash"
                           align="center"
                           label="返现金额(元)或比例 %"
                           width="160">
            <template slot-scope="{ row }">
              {{ Number(row.reward_share) == 0 ? Number(row.reward_cash) + " 元" : Number(row.reward_share) + " %" }}
            </template>
          </el-table-column>
          <el-table-column v-if="activeName == 'activity_share'"
                           prop="rule_type"
                           align="center"
                           label="返现次数"
                           width="160">
            <template slot-scope="scope">
              {{scope.row.rule_type==1?'不限次数':scope.row.rule_type}}
            </template>
          </el-table-column>
          <el-table-column v-if="activeName == 'activity_link'"
                           prop="limit_order_num"
                           align="center"
                           label="购买次数"
                           width="160"> </el-table-column>
          <el-table-column prop="activity_name"
                           align="center"
                           label="参与活动"
                           width="160"> </el-table-column>
          <el-table-column prop="status"
                           align="center"
                           label="状态"
                           width="160">
            <template slot-scope="{ row }">
              <div><span :class="'done' + row.status"></span> {{ status_opt[row.status - 1] }}</div>
              <!--   <div v-else><span class="done4"></span> 失效</div> -->
            </template>
          </el-table-column>
          <el-table-column fixed="right"
                           align="center"
                           label="操作"
                           width="200">
            <template slot-scope="{ row }">
              <div class="link">
                <el-link type="primary"
                         @click="Detail(row)">查看</el-link>
                <!--  <el-link
                                    type="primary"
                                    @click="Invalid(row)"
                                    v-show="(row.invalid_time == null && row.status == ) || (row.invalid_time == null && row.status == 2)"
                                    >失效</el-link
                                > -->
                <!--  <el-link type="primary" v-show="row.status == 3 || row.status == 4 || row.invalid_time != null" @click="routeTo(row)">效果数据</el-link> -->
                <el-link type="primary"
                         v-show=" row.status == 1"
                         @click="Edit(row)">编辑</el-link>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="selectAll">
          <div>
            <el-checkbox v-model="selectAll"
                         @change="selectProduct">当前页全选</el-checkbox>
            <p style="margin: 0 22px">已选 {{ multipleSelection.length }} 个商品</p>
            <el-button type="warning"
                       size="small"
                       @click="productInvalidAllFunc">失效</el-button>
          </div>
          <el-button type="danger"
                     size="small"
                     @click="clearData">清空</el-button>
        </div>
        <div class="page">
          <el-pagination @size-change="sizeChange"
                         @current-change="handleSizeChange"
                         :current-page="page"
                         :page-sizes="[10, 20, 30, 40]"
                         :page-size="size"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total"
                         background>
          </el-pagination>
        </div>
      </div>
    </div>
    <EditActivity ref="refEditActivity"
                  @init="init"
                  :activeName="activeName"></EditActivity>
    <Detail ref="refDetail"
            :activeName="activeName"></Detail>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EditActivity from "./EditActivityGoods.vue";
import Detail from "./Detail.vue";
export default {
  components: {
    EditActivity,
    Detail,
  },
  data () {
    return {
      form: {
        spuId: "",
        productName: "",
        merchandise_inventory: [],
        prices_mains: [],
      },
      customers: [],
      customer: [],
      activeName: "activity_team",
      options: [],
      tableData: [],
      multipleSelection: [],
      selectAll: false,
      total: 0,
      size: 10,
      page: 1,
      status_opt: ["未开始", "进行中", "已结束", "失效"],
      tableLoad: false,
    };
  },
  mounted () {
    if (this.$route.query.type) {
      this.activeName = this.$route.query.type;
    }
    this.getGoodsClass();
    this.getGoodsList();
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  methods: {
    ...mapActions({
      getGoodLei: "commodity/getGoodLei",
      getDetailedList: "commodity/getDetailedList",
      productInvalid: "commodity/productInvalid",
      productInvalidAll: "commodity/productInvalidAll",
    }),

getRowKeys (row) {
      return row.activity_goods_id;
    },
    checkSelectable (row) {
      console.log(row.status, '5')
      if (row.status == 4) {
        return false
      } else {
        return true
      }

    },
    routeTo (row) {
      this.$router.push({
        path: "/home/performanceData",
        query: {
          type: this.activeName,
          activity_id: row.activity_goods_id,
          product_id: row.product_id,
        },
      });
    },
    clearData () {
      this.multipleSelection = [];
      this.getGoodsList();
    },
    productInvalidAllFunc () {
      if (this.multipleSelection.length == 0) {
        return this.$message.warning("请选择商品！");
      }

      this.$confirm("是否确认所选商品失效?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = [];
          this.multipleSelection.forEach((item) => {
            data.push(item.activity_goods_id);
          });

          let params = {
            token: this.getToken,
            /*  activity_name: this.activeName, */
            ids: data.join(','),
          };
          this.productInvalidAll(params).then((data) => {
            console.log(data);
            if (data.code == 1) {
              this.$message.success("操作成功！");
              this.getGoodsList();
              this.multipleSelection = []
            } else {
              this.$message.error(data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    Detail (row) {
      this.$refs.refDetail.bindData(row);
      this.$refs.refDetail.dialogVisible = true;
    },
    Edit (row) {

      //  row.is_open_leader_price_data = row.is_open_leader_price;
      row.leader_price = Number(row.leader_price) == 0 ? "" : row.leader_price;
      row._reward_share = Number(row.reward_share) == 0 ? "" : Number(row.reward_share) || "";
      row._reward_cash = Number(row.reward_cash) == 0 ? "" : Number(row.reward_cash) || "";
      this.$refs.refEditActivity.ruleForm = JSON.parse(JSON.stringify(row));
      this.$refs.refEditActivity.dialogVisible = true;
    },
    Invalid (row) {
      this.$confirm("是否确认失效？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            token: this.getToken,
            activity_name: this.activeName,
            activityProductId: row.id,
            activityId: row.activity_data.id,
          };
          this.productInvalid(params).then((res) => {
            console.log(res);
            if (res.code == 1) {
              this.$message.success("操作成功");
              this.getGoodsList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleClick () {
      this.tableData = [];
      this.getGoodsList();
    },
    handleSelectionChange (val) {
      console.log(val);
      this.multipleSelection = val;
      if (this.multipleSelection.length != this.tableData.length) {
        this.selectAll = false;
      } else {
        this.selectAll = true;
      }
    },
    selectProduct () {
      this.$refs.multipleTable.toggleAllSelection();
    },
    init () {
      this.form = {
        spuId: "",
        productName: "",
        merchandise_inventory: [],
        prices_mains: [],
      };
      this.getGoodsList();
    },
    getGoodsList () {
      this.tableLoad = true;
      let params = {
        token: this.getToken,
        activity_type: this.activeName == 'activity_link' ? 1 : this.activeName == 'activity_team' ? 2 : 3,
        product_id: this.form.spuId,
        goods_name: this.form.productName,
        merchandise_inventory: this.form.merchandise_inventory,
        price_sell: this.form.prices_mains,
        page: this.page,
        size: this.size,

      };
      this.getDetailedList(params).then((res) => {
        this.tableLoad = false;
        if (res.code == 1) {
          this.tableData = res.data.data;
          this.total = res.data.count;
        }
      });
    },
    selChange (val) {
      console.log(this.form.class);
    },
    getGoodsClass () {
      this.getGoodLei({
        token: this.$store.state.token,
        classifys_type_id: 2000,
      }).then((res) => {
        if (res.code == 1) {
          this.options = res.data.treeData;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleSizeChange (val) {
      this.page = val;
      this.getGoodsList();
    },
    sizeChange (val) {
      this.size = val;
      this.getGoodsList();
    },
  },
};
</script>

<style lang="scss" scoped>
.selectAll {
  padding: 20px;
  background: #f4f4f5;
  color: #666;
  margin-top: 20px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > div {
    display: flex;
    align-items: center;
  }
  ::v-deep .el-checkbox__label {
    color: #666;
  }
}
::v-deep .el-tabs__item {
  padding: 0 42px !important;
}
::v-deep .el-tabs__active-bar {
  width: 126px !important;
  left: -43px;
}
.title {
  box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
  width: 100%;
  background: #fff;
  font-size: 18px;
  color: #333;
  width: 100%;
  padding: 15px 32px;
}
.main {
  box-shadow: 0px 0px 8px 0px rgba(100, 100, 100, 0.17);
  background: #fff;
  margin: 24px;
  padding: 30px;
  padding-bottom: 70px;
  min-width: 1200px;
  span {
    margin-right: 10px;
    ::v-deep .el-input {
      width: 300px;
      display: inline-block;
    }
  }
}
::v-deep .el-table__body-wrapper {
  min-height: 450px;
}
.page {
  margin-top: 20px;
  float: right;
}
.link {
  a {
    margin: 0 8px;
  }
}
.el-cascader {
  ::v-deep .el-input {
    width: 320px !important;
  }
}
.done1 {
  display: inline-block;
  width: 12px;
  height: 12px;
  background: #fb252f;
  border-radius: 50%;
  transform: translateY(1px);
}
.done2 {
  display: inline-block;
  width: 12px;
  height: 12px;
  background: #2448ff;
  border-radius: 50%;
  transform: translateY(1px);
}
.done3 {
  display: inline-block;
  width: 12px;
  height: 12px;
  background: #333;
  border-radius: 50%;
  transform: translateY(1px);
}
.done4 {
  display: inline-block;
  width: 12px;
  height: 12px;
  background: #999;
  border-radius: 50%;
  transform: translateY(1px);
}

.mr40 {
  .el-form-item {
    margin-right: 40px;
  }
  .mr20 {
    margin-right: 10px;
  }
}
</style>
